type functionResult = [string, string, string, string];

export const getMetrics = (): functionResult => {
  return ['wt', 'cpu', 'mu', 'pmu'];
};
